"use client";
import Link from "next/link";

interface NavCardPageProps {
  setActiveDropdown: (value: null) => void;
  title: string;
  description: string;
  iconSrc: React.ElementType;
  titleButton: string;
  linkHref: string;
}
export default function NavCardPage({
  setActiveDropdown,
  title,
  description,
  iconSrc,
  titleButton,
  linkHref,
}: NavCardPageProps) {
  const Icon = iconSrc;
  return (
    <>
      <div className="mb-6">
        <div className="w-14 h-14 bg-white/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[var(--acento-nav)]/20 transition-colors duration-300">
          <Icon className="w-8 h-8 text-[var(--acento-nav)]" />
        </div>
        <h2 className="text-2xl font-bold text-white leading-tight">{title}</h2>
      </div>
      <p className="font-medium text-white/70 leading-relaxed mb-8 flex-1">
        {description}
      </p>
      <Link
        href={linkHref}
        className="bg-[var(--acento-nav)] text-[var(--fondoGeneral-secciones)] hover:brightness-110 font-semibold py-3.5 px-6 rounded-xl text-center transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 flex items-center justify-center gap-2 group/btn"
        onClick={() => setActiveDropdown(null)}
      >
        <span>{titleButton}</span>
        <svg
          className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-200"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </Link>
    </>
  );
}
